const GoogleSignIn = {}

export {
  GoogleSignIn
}
